import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import { constants } from 'helpers'
import { useFt } from 'hooks'
import { useUser } from 'modules/user'

import { HeroMediaBlock, Image, Text } from 'components/dataDisplay'

import { WidthContainer } from 'components/layout'
import heroImageDesktopFemale from './images/hero-image-desktop.jpg'
import heroImageDesktopMale from './images/hero-male-desktop.jpg'
import heroImageDesktopNoCase from './images/hero-image-desktop-no-case.jpg'
import heroImageMobileFemale from './images/hero-image-mobile.jpg'
import heroImageMobileMale from './images/hero-male-desktop.jpg'
import heroImageMobileNoCase from './images/hero-image-mobile-no-case.jpg'

import scentbirdSelectLogo from './images/scentbird-select-logo.png?src-loader'
import messages from './messages'


const HERO_IMAGE_HEIGHT_DESKTOP = 460
const HERO_IMAGE_HEIGHT_MOBILE = 300

export type HeroSectionProps = {
  title?: Intl.Message | string
  description?: Intl.Message | string
}

const HeroSection: React.FunctionComponent<HeroSectionProps> = (props) => {
  const { title, description } = props
  const { isMobile } = useDevice()
  const { gender } = useUser()
  const isMale = gender === 'MALE'

  const isSaksGreyCaseEnabled = useFt(constants.features.saksGreyCase)

  const heroImageDesktop = isSaksGreyCaseEnabled ? heroImageDesktopNoCase : (isMale ? heroImageDesktopMale : heroImageDesktopFemale)
  const heroImageMobile = isSaksGreyCaseEnabled ? heroImageMobileNoCase : (isMale ? heroImageMobileMale : heroImageMobileFemale)

  const withTitle = Boolean(title)

  return (
    <>
      <HeroMediaBlock>
        <HeroMediaBlock.Image
          src={isMobile ? heroImageMobile : heroImageDesktop}
          height={isMobile ? HERO_IMAGE_HEIGHT_MOBILE : HERO_IMAGE_HEIGHT_DESKTOP}
        />
      </HeroMediaBlock>
      <WidthContainer className="-mt-32">
        <div className={cx('bg-black-100 text-center text-white', isMobile ? 'px-16 pb-24' : 'pb-32')}>
          <Image
            className={isMobile ? 'mt-32 w-[294rem]' : 'mt-32 w-[366rem]'}
            src={scentbirdSelectLogo.src}
            aspect={scentbirdSelectLogo.aspect}
          />
          {
            withTitle && (
              <Text className={isMobile ? 'my-16' : 'my-24'} message={title} style="h5" color="gold-30" html />
            )
          }
          <Text className={!withTitle && 'mt-24'} message={description || messages.description} style={isMobile ? 'p3' : 'p2'} html />
        </div>
      </WidthContainer>
    </>
  )
}

export default HeroSection
